// extracted by mini-css-extract-plugin
export var errorIcon = "_qi-1";
export var nameLogo = "_qi-0";